import { Component } from "@angular/core";

import { SvgMixinComponent } from "../svg-mixin.component";

@Component({
  selector: "med-icon-view-boxes",
  templateUrl: "./med-icon-view-boxes.component.html",
})
export class MedIconViewBoxesComponent extends SvgMixinComponent {}
